// extracted by mini-css-extract-plugin
export default {"header":"PM","container":"QM","accordeonitem":"RM","itemsticky":"SM","itemopen":"TM","open":"UM","productname":"VM","productinfo":"WM","flavorstext":"XM","invalidlimit":"YM","limit":"ZM","scrollUpAccordion":"aN","wrapper":"bN"};
    if(module.hot) {
      // 1713969935314
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  